import { inViewMargin } from '@helpers/animate';
import { imageUrl, srcSet } from '@helpers/image';
import { Device, from } from '@helpers/media';
import { useInView } from '@hooks/useInView';
import * as React from 'react';
import S from './ImageBlock.styles';
const ImageBlock = ({ data }) => {
    const [refContainer, inView] = useInView({ rootMargin: inViewMargin });
    const size = data.imageSize || 1;
    return (React.createElement(S.Container, { ref: refContainer, initial: "hidden", animate: inView ? 'visible' : 'hidden', variants: {
            hidden: {
                opacity: 0,
                y: 20,
            },
            visible: {
                opacity: 1,
                y: 0,
            },
        } },
        React.createElement("picture", null,
            React.createElement("source", { media: from(Device.Desktop), srcSet: srcSet(data.image, { width: 1604 * size }) }),
            React.createElement("source", { media: from(Device.DesktopSmall), srcSet: srcSet(data.image, { width: 1329 * size }) }),
            React.createElement("source", { media: from(Device.TabletLarge), srcSet: srcSet(data.image, { width: 1243 * size }) }),
            React.createElement("source", { media: from(Device.Tablet), srcSet: srcSet(data.image, { width: 987 * size }) }),
            React.createElement("source", { media: from(Device.MobileLarge), srcSet: srcSet(data.image, { width: 731 * size }) }),
            React.createElement(S.Image, { alt: data.image.altText, loading: "lazy", src: imageUrl(data.image, { width: 443 * size }), srcSet: srcSet(data.image, { width: 443 * size }), maxHeight: data.maxHeight, size: size }))));
};
export default ImageBlock;
